// Wrapper minimal peste Web Notifications API
// IMPORTANT: cererea de permisiune trebuie făcută DIN gestul utilizatorului (click) — nu auto la mount.
const SUPPRESS_BANNER_KEY = "tom-notif-banner-suppressed";

export function isSupported() {
    return typeof window !== "undefined" && "Notification" in window;
}

export function getPermission() {
    if (!isSupported()) return "unsupported";
    return Notification.permission;
}

export function suppressBanner() {
    try { localStorage.setItem(SUPPRESS_BANNER_KEY, String(Date.now())); } catch { /* ignore */ }
}

export function isBannerSuppressed() {
    try { return !!localStorage.getItem(SUPPRESS_BANNER_KEY); } catch { return false; }
}

// Trebuie chemată DIN handler-ul unui click (gest user). Întoarce permisiunea finală.
export async function requestPermission() {
    if (!isSupported()) return "unsupported";
    if (Notification.permission === "granted" || Notification.permission === "denied") {
        return Notification.permission;
    }
    try {
        return await Notification.requestPermission();
    } catch {
        return "default";
    }
}

export function showNotification(title, { body = "", tag = "", onClick = null, force = false } = {}) {
    if (!isSupported() || Notification.permission !== "granted") return null;
    // Nu re-emite dacă tab-ul este activ (decât dacă force=true, pentru "test")
    if (!force && typeof document !== "undefined" && document.visibilityState === "visible") return null;
    try {
        const n = new Notification(title, {
            body,
            tag: tag || undefined,
            icon: "/logo-tom-v3.png",
            badge: "/logo-tom-v3.png",
        });
        if (onClick) {
            n.onclick = (e) => {
                e.preventDefault();
                try { window.focus(); } catch { /* ignore */ }
                onClick();
                n.close();
            };
        }
        return n;
    } catch {
        return null;
    }
}
